import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import $user from '@/store/modules/user';
import $menu from '@/store/modules/menu';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    $user,
    $menu
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js